export const FREE_SONG_KEY = "pixels-and-glass-free-2026";
export const FREE_SONG_EXPIRY = "08 July 2027";

export const BOOKS = [
  {
    id: "suspicious-times",
    type: "book",
    title: "Suspicious Times",
    fullTitle: "Suspicious Times: Elvis and the Time Travellers",
    tagline: "Elvis and the Time Travellers",
    genre: "Sci-Fi Time Travel",
    price: 8.55,
    available: true,
    cover: "/covers/suspicious-times.png",
    accent: "#9b6dff",
    hook: "The past is never as settled as it seems.",
    blurb:
      "When a chance encounter catapults Elvis Presley into a hidden war across time, he discovers that history is fragile — and the future is in peril. With the help of a brilliant time-traveller and a hardened ally from a world he never knew, Joshua, Samantha and Elvis must navigate dangerous eras, unravel a shadowy conspiracy, and set things right before time unravels completely.",
    extra:
      "From the bright lights of 1970s America to vastly different civilisations and dystopian futures, their journey is filled with relentless foes, unbreakable bonds, and the power of choice. Four interconnected novels under one cover: The Meeting · The Conspiracy · The Correction of Time · Where Strangers Meet.",
  },
  {
    id: "youre-never-safe",
    type: "book",
    title: "You're Never Safe",
    fullTitle: "You're Never Safe",
    tagline: "A romantic thriller of love, betrayal and survival",
    genre: "Romantic Thriller",
    price: 8.55,
    available: true,
    cover: "https://static.prod-images.emergentagent.com/jobs/a64ea50c-ae83-4952-998e-a074918f1c93/images/7788e98485f7c3c06f84354d55261887de99eac6b2e2b3ad448ccd5127f62ddf.png",
    accent: "#3aa0ff",
    hook: "Love brought them together. Danger will test them forever.",
    blurb:
      "A dream holiday. A deadly secret. And a syndicate that will stop at nothing. When Joshua and Sam's dream getaway turns into a fight for their lives, they must outrun, outsmart, and outlast a ruthless criminal network determined to see them dead.",
    extra:
      "Because when you're in their sights, you're never safe. A thrilling love story, nonstop suspense, and an international adventure with danger at every turn.",
  },
  {
    id: "survival",
    type: "book",
    title: "Survival",
    fullTitle: "Survival",
    tagline: "A short story of resilience and ruthlessness",
    genre: "Post-Apocalyptic",
    price: 8.55,
    available: true,
    cover: "https://static.prod-images.emergentagent.com/jobs/a64ea50c-ae83-4952-998e-a074918f1c93/images/05556137ccd6f1832c17c512abd34d5235a8b8a9acf4f365bd7c9a5005d4835c.png",
    accent: "#d6453a",
    hook: "In a world devastated by disaster, trust is the rarest currency.",
    blurb:
      "Survival is a gripping tale of two individuals, Samantha and Josh, struggling to stay alive in a world devastated by disaster and uncertainty. Set against a post-fallout backdrop where acid rain and hidden agendas pose a constant threat, they stumble upon a secret underground facility ruled by a manipulative leader whose power rests on secrecy and control.",
    extra:
      "The discovery of an elaborate plan for extermination sets the stage for a thrilling showdown between the oppressed and the oppressor — a narrative of suspense and intrigue exploring resilience, sacrifice, and the human capacity for both compassion and ruthlessness.",
  },
  {
    id: "dingo",
    type: "book",
    title: "Dingo, He's Called",
    fullTitle: "Dingo, He's Called",
    tagline: "A novel of survival in the far north of South Australia",
    genre: "Outback Adventure",
    price: 8.55,
    available: true,
    newRelease: true,
    cover: "/covers/dingo-v2.jpg",
    accent: "#e0982f",
    hook: "From Leigh Creek, on the Strzelecki Track, a legend of lost gold comes alive.",
    blurb:
      "Deep in the far north of South Australia, where the red desert swallows the unprepared, a legend of lost gold draws a lone man onto the Strzelecki Track. This is a story of grit, isolation, and the unforgiving beauty of the outback.",
    narrative:
      "Dingo, He's Called is a high-octane outback thriller that blends survival realism with speculative science fiction.",
    narrative2:
      "The story follows Steven, a twenty-one-year-old hardware store employee from Adelaide who seizes an unexpected career opportunity to become an assistant manager at a regional branch in Leigh Creek. Eager to experience the outback, Steven ignores practical warnings and takes an unauthorised Sunday drive up the rugged Strzelecki Track, where a shredded tyre and lost water leave him stranded in the blistering desert heat. He is rescued by Dingo, an enigmatic ex-army infantry veteran and grizzled prospector accompanied by his scarred blue heeler, Browny. As Dingo teaches Steven the harsh realities of desert survival, the two stumble upon an 1800s mine shaft containing a legendary, untouched quartz reef rich in raw gold.",
    narrative3:
      "However, they soon discover they are not alone in the remote interior. An international cartel warlord operating from Mount Kosciuszko, elite mercenaries, state police tactical units led by outback veteran Captain Jock \"Bluey\" McDonald, and terrifying subterranean silicon-and-metal titans converge on the ridge in a catastrophic clash of greed, survival, and ancient earthly forces.",
    setting:
      "South Australia's outback: Leigh Creek, the Strzelecki Track, and the Arkaroola Wilderness Sanctuary",
    characters: [
      { name: "Steven", desc: "A naive city transplant whose journey from a sheltered retail clerk to a resilient outback survivor forms the emotional core of the narrative." },
      { name: "Dingo", desc: "A battle-hardened former SASR sniper whose tactical expertise, military discipline, and deep respect for the outback keep them alive against impossible odds." },
      { name: "Captain Jock \"Bluey\" McDonald", desc: "A barrel-chested, 67-year-old Scottish ex-coal miner and outback legend who leads the regional search-and-rescue vanguard." },
      { name: "The Texan", desc: "A ruthless international cartel warlord driven by pathological greed and absolute control." },
    ],
  },
];

export const SONG = {
  id: "pixels-and-glass",
  type: "song",
  title: "Pixels and Glass",
  tagline: "A single by Michael Leckie",
  genre: "Single",
  price: 1.29,
  available: true,
  cover: "https://static.prod-images.emergentagent.com/jobs/a64ea50c-ae83-4952-998e-a074918f1c93/images/217351c3bc92a4b533355ea322df1974fc1c7ade1668f54a805e87a3dc13f8b5.png",
  accent: "#2ec5d6",
  hook: "Where do I end and the myth begin?",
  blurb:
    "Pixels and Glass is an original single by author and storyteller Michael Leckie. Own the track, or grab it free if you've found the secret QR code.",
  narrative:
    "Pixels and Glass is a haunting ballad sung from the perspective of a legend who has outlived his own era. Picture Elvis — the King — alive in our hyper-connected age, alone in a glass Vegas tower, watching ghosts of himself flicker across a thousand strangers' screens. The neon that once promised escape has been swapped for cold LED; fame has become a \"digital sky\" he's trapped inside, a single heartbeat behind a firewall he can't even see.",
  narrative2:
    "It's a song about the loneliness of being everywhere and nowhere at once — of trading the static of a tube TV, the hum of crickets on a porch, and a song kept secret between two people, for mentions, trending charts and the global roar. Beneath the gold and the crown is a man asking the only question that still matters: where does he end and the myth begin?",
  narrative3:
    "Tying directly into the world of Suspicious Times: Elvis and the Time Travellers, \"Pixels and Glass\" is the King's quiet reckoning with a future he was never meant to see — proof that some truths money, fame, and even time itself can't buy.",
  lyrics: [
    { section: "Verse 1", lines: [
      "The neon's different in Vegas now",
      "It don't hum the same, it don't show you how",
      "To lose yourself in a midnight glow",
      "Now it's all LED and a digital show.",
      "I'm sitting high in a penthouse suite",
      "Watching ghosts of me walking down the street",
      "On a thousand screens in a stranger's hand",
      "A hologram king in a hollow land.",
    ]},
    { section: "Chorus", lines: [
      "And it's all just pixels, it's all just glass",
      "Watching the ghost of the future pass.",
      "I still got the gold, I still got the crown",
      "But the world got quiet as the lights went down.",
      "I'm a heartbeat trapped in a digital sky",
      "Looking for a truth that money can't buy.",
      "Oh, money can't buy",
    ]},
    { section: "Verse 2", lines: [
      "They tell me I'm \"trending,\" whatever that means",
      "Better to be loved than caught in the machines.",
      "Memphis is further than it used to be",
      "Behind a firewall I can't even see.",
      "I miss the static on a tube TV",
      "When a song was a secret between you and me",
      "Before the whispers turned to a global roar",
      "And nobody knocks on the heavy front door.",
    ]},
    { section: "Bridge", lines: [
      "I'd trade the mentions and the vanity fair",
      "For a ride in the Stutz and some humid air.",
      "To stand on the porch while the crickets sing",
      "And feel the weight of a simple thing.",
    ]},
    { section: "Chorus", lines: [
      "Yeah, it's all just pixels, it's all just glass",
      "Watching the ghost of the future pass.",
      "I still got the gold, I still got the crown",
      "But the world got quiet as the lights went down.",
      "I'm a heartbeat trapped in a digital sky",
      "Looking for a truth that money can't buy.",
      "Oh money can't buy",
    ]},
    { section: "Outro", lines: [
      "The blue suede's faded, the velvet's thin",
      "Where do I end and the myth begin?",
      "Just a man in the mirror, looking for home",
      "The King of the world... and all alone.",
      "(Slow fade with a soulful hum)",
    ]},
  ],
};

export const BUNDLE = {
  id: "complete-collection",
  type: "bundle",
  title: "The Complete Collection",
  tagline: "All four novels — one download",
  genre: "Bundle",
  price: 28.5,
  available: true,
  hook: "Four worlds. One library. One price.",
  blurb:
    "Get all four of Michael Leckie's novels — Survival, You're Never Safe, Suspicious Times: Elvis and the Time Travellers, and Dingo, He's Called — delivered together as a single download. The complete collection for less than buying each on its own.",
};

export const ALL_PRODUCTS = [...BOOKS, SONG, BUNDLE];

export const getProduct = (id) => ALL_PRODUCTS.find((p) => p.id === id);
